;(function (angular, _, moment) {
  'use strict'

  angular
    .module('kilo.routes.invoice.show', [])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = ['$stateProvider', 'populates']

  function RouteConfigurator ($stateProvider, populates) {
    const baseState = {
      // Retire le watcher $rootScope de la pagination résolue à la sortie de l'état
      // (baseState est recopié dans chaque état : chacun résout et détruit la sienne)
      onExit: ['creditNotePagination', function (creditNotePagination) { creditNotePagination.destroy() }],
      resolve: {
        creditNotePagination: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('tmp-creditNoteList', { perPage: 5 })
        }],
        template: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getInvoicePrefs().then(function (prefs) {
            return prefs.numberFormat
          })
        }],
        initParams: ['$stateParams', function ($stateParams) {
          return $stateParams.initParams
        }],
        customFields: ['CustomFieldManager', function (CustomFieldManager) {
          return CustomFieldManager.get(
            CustomFieldManager
              .query()
              .select('invoice', 'model')).then(function (data) {
            return data.data
          })
        }],
        vats: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getCompanyPrefs().then(function (prefs) {
            return prefs.vats
          })
        }],
        generalPrefs: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getGeneralPrefs()
        }],
        model: [() => {
          return 'invoice'
        }]
      },
      params: {
        initParams: {}
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/invoice/show/templates/invoice-show.template.html',
          controller: 'ElementShowController',
          controllerAs: 'show'
        },
        'toolbar@': {
          templateUrl: '/app/modules/invoice/show/templates/invoice-show-toolbar.html',
          controller: 'InvoiceShowToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: '{{toolbar.status === \'draft\' ? toolbar.title : toolbar.number | truncate: 50}}' + '{{toolbar.status === \'draft\' && !toolbar.invoice.isModel ? \' (Brouillon)\' : \'\'}}' + '{{toolbar.invoice.isModel ? \' (Modèle de facture pré-rempli)\' : \'\'}}',
        parent: 'invoice.list'
      }
    }

    var showState = {
      ...baseState,
      resolve: {
        fromQuote: ['QuoteManager', 'element', function (QuoteManager, element) {
          return QuoteManager.get(
            QuoteManager.query({
              conditions: {
                invoice: element._id
              }
            })
          ).then(function (data) {
            return data.data[0]
          })
        }],
        fromToDeposit: ['QuoteManager', 'element', function (QuoteManager, element) {
          return QuoteManager.get(
            QuoteManager.query({
              conditions: {
                invoiceDeposit: element._id
              }
            })
          ).then(function (data) {
            return data.data[0]
          })
        }],
        ...baseState.resolve,
        element: ['$stateParams', 'InvoiceManager', function ($stateParams, InvoiceManager) {
          return InvoiceManager.findById($stateParams.id, InvoiceManager.query({
            populate: JSON.stringify(populates.show.invoice)
          })
          )
        }]
      },
      name: 'invoice.show',
      url: '/{id:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}'
    }

    var newState = {
      ...baseState,
      name: 'invoice.new',
      url: '/new',
      resolve: {
        fromQuote: function () {},
        fromToDeposit: function () {},
        ...baseState.resolve,
        element: ['InvoiceService',
          function (InvoiceService) {
            return InvoiceService.createInvoiceFromPreferences()
          }]
      },
      ncyBreadcrumb: {
        ...baseState.ncyBreadcrumb,
        label: 'Création d\'une facture'
      }
    }

    var showTemplate = {
      ...baseState,
      resolve: {
        fromQuote: function () {},
        fromToDeposit: function () {},
        ...baseState.resolve,
        element: ['$stateParams', 'InvoiceManager', function ($stateParams, InvoiceManager) {
          return InvoiceManager.findById($stateParams.id, InvoiceManager.query({
            populate: JSON.stringify([
              { path: 'client' },
              { path: 'delivery' },
              { path: 'tags' },
              { path: 'referers' },
              { path: 'bpu', populate: [{ path: 'client' }] },
              { path: 'lines.subcontracts.entity' },
              { path: 'lines.product.productType' },
              { path: 'lines.productType' }
            ])
          })
          )
        }]
      },
      name: 'invoice.showTemplate',
      url: '/{id:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}'
    }

    var newTemplate = {
      ...baseState,
      name: 'invoice.newTemplate',
      url: '/newTemplate',
      resolve: {
        ...baseState.resolve,
        element: ['InvoiceManager',
          function (InvoiceManager) {
            return InvoiceManager.create({
              status: 'draft',
              isModel: true
            }
            )
          }],
        fromQuote: function () {},
        fromToDeposit: function () {}
      },
      ncyBreadcrumb: {
        ...baseState.ncyBreadcrumb,
        label: 'Création d\'un modèle de facture pré-rempli'
      }
    }

    $stateProvider
      .state(showState)
      .state(newState)
      .state(showTemplate)
      .state(newTemplate)
  }
})(window.angular, window._, window.moment)
